// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__31Pe6","footer":"ReportModalFilter_footer__A_SnY"};